import { WorkingCardItem } from "./types";

export const WORKING_CARDS: readonly WorkingCardItem[] = [
  {
    label: "Safe-to-Spend",
    value: "£3,247",
    variant: "highlight",
  },
  {
    label: "VAT to protect",
    value: "£3,910",
    variant: "default",
  },
  {
    label: "Protected tax balance",
    value: "£1,263",
    variant: "default",
  },
  {
    label: "Confidence level",
    value: "High",
    variant: "success",
  },
] as const;
